"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default(_ref) {
  var compilerService = _ref.compilerService;
  return {
    name: 'exec',
    synopsis: 'exec [COMMAND STRING]',
    description: 'Execute a string as a command',
    execute: function execute(args) {
      var compiled = compilerService.compile(args.join(' '));
      return compiled();
    }
  };
};

exports.default = _default;